import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import useDebounce from 'modules/common/hooks/useDebounce';
import GenericListPair from 'modules/common/components/GenericListPair';
import * as actions from '../action';
import * as c from '../constant';
import MunicipalityContent from './MunicipalityContent';
import UpdateDetailModal from '../components/UpdateDetailModal';

const INIT_FILTER = {
  sort_by: 'desc',
  isPaginate: 1,
  q: '',
  region_code: '',
  province_code: '',
};

function MuncipalityContainer({
  match,
  isLoading,
  history,
  getMunicipalityList,
  municipalityList,
  municipalityListPager,
  getRegionsList,
  getProvinceList,
  regionsList,
  provinceList,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const INIT_STATE = {
    label: '',
    value: 0,
  };
  const [region, setRegion] = useState(INIT_STATE);
  const [province, setProvince] = useState(INIT_STATE);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getRegionsList({ per_page: 1000 });
  }, []);

  useEffect(() => {
    getProvinceList({
      per_page: 1000,
      ...(region.value && { region_code: region.value }),
    });
  }, [JSON.stringify(region)]);

  useEffect(() => {
    getMunicipalityList(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e) => {
    setRegion(e);
    setFilter((prev) => ({
      ...prev,
      q: '',
      province_code: '',
      region_code: e.value,
    }));
    setProvince(INIT_STATE);
  };

  const handleProvinceSelect = (e) => {
    setProvince(e);
    setFilter((prev) => ({ ...prev, q: '', province_code: e.value }));
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateDetailModal
          municipalityInfo={data.attributes}
          selected={data.id}
        />
      ),
      title: 'Update Municipality',
      modalSize: 'modal-md',
    });
  };

  return (
    <Route
      path={`${match.path}/:municipalityId?`}
      render={({ match: { params } }) => (
        <div>
          <div className="card p-0 mb-3 mt-3">
            <div className="container-fluid d-flex px-0">
              <div className="d-inline w-auto d-flex justify-content-start m-3">
                <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
                  Select Region:
                </label>
                <div style={{ width: 250 }}>
                  <Select
                    styles={customStyle}
                    placeholder="Select Region"
                    value={region}
                    options={createDropdown(regionsList)}
                    onChange={(e) => {
                      handleChangeSelect(e);
                    }}
                  />
                </div>
              </div>
              <div className="d-inline w-auto d-flex justify-content-start m-3">
                <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
                  Select Province:
                </label>
                <div style={{ width: 250 }}>
                  <Select
                    styles={customStyle}
                    placeholder="Select Province"
                    value={province}
                    options={createDropdown(provinceList)}
                    onChange={handleProvinceSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          <GenericListPair
            moduleName="City/Municipality List"
            // getData={getMunicipalityList}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search City/Municipality..."
            listName="Municipality"
            label="City/Municipality"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.municipalityId}
            data={municipalityList}
            dataPager={municipalityListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:municipalityId?`}
                    render={() => (
                      <MunicipalityContent handleEdit={handleEdit} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:municipalityId?`}
                  render={() =>
                    !params.municipalityId && municipalityList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(municipalityList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        </div>
      )}
    />
  );
}

MuncipalityContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityListPager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_MUNICIPALITY_LIST) > -1,
  municipalityList: _.get(api, `${c.GET_MUNICIPALITY_LIST}.list`) || [],
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityListPager: _.get(api, `${c.GET_MUNICIPALITY_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MuncipalityContainer);
